import Swiper from "swiper/bundle";

export const productGallery = () => {
  const $productGalleries = document.querySelectorAll(
    "section.product-gallery"
  );
  $productGalleries.forEach(($productGallery) => {
    const $tribeProductGalleryContents = $productGallery.querySelector(
      ".product-gallery__contents"
    );

    const $navLeft =
      $tribeProductGalleryContents?.querySelector(".swiper__prev");
    const $navRight =
      $tribeProductGalleryContents?.querySelector(".swiper__next");

    const $wrapperSwiper = $tribeProductGalleryContents.querySelector(
      ".wrapper__swiper.swiper"
    );
    if ($wrapperSwiper) {
      const swiperConfig = {
        direction: "horizontal",
        speed: 1000,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 12,
      };
      if ($navLeft && $navRight) {
        swiperConfig.navigation = {
          nextEl: $navRight,
          prevEl: $navLeft,
        };
      }
      const swiperObject = new Swiper($wrapperSwiper, swiperConfig);
    }
  });
};

export default productGallery;
